var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7373 15.854C21.7225 13.3949 22.8718 11.5416 25.1928 10.1751C23.8947 8.37227 21.9308 7.38072 19.3419 7.18962C16.8907 7.00213 14.2089 8.57419 13.2269 8.57419C12.1891 8.57419 9.81602 7.25453 7.94878 7.25453C4.09528 7.31222 0 10.2328 0 16.1749C0 17.9308 0.331044 19.7444 0.993133 21.6121C1.8784 24.0712 5.06981 30.0962 8.39886 29.9988C10.1396 29.9592 11.3708 28.8018 13.6361 28.8018C15.8343 28.8018 16.9725 29.9988 18.9142 29.9988C22.273 29.952 25.1594 24.475 26 22.0088C21.4956 19.9499 21.7373 15.9801 21.7373 15.854ZM17.828 4.85678C19.7139 2.68619 19.5428 0.710309 19.487 0C17.8206 0.0937464 15.8938 1.09972 14.7966 2.33645C13.5877 3.66332 12.8773 5.30388 13.0298 7.15357C14.83 7.28698 16.4741 6.38917 17.828 4.85678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.c74467f4eeae748f0d02258683db3eaa.svg";
export { ForwardRef as ReactComponent };